import { InjectionToken } from '@angular/core';

/**
 * Bridge to the AngularJS ui-router `$state` service.
 *
 * New Angular 18 components are downgraded into the AngularJS ui-router tree,
 * so there is no Angular `ActivatedRoute`; the live route/query params live on
 * `$state.params`. Used by RouteParamsService to read params such as the
 * Zendesk `return_to`.
 *
 * Reference: @uirouter/angularjs `$state` (apps/b2b-ui).
 */
export interface IStatePort {
  params: Record<string, string | null | undefined>;
}

export const STATE_PORT = new InjectionToken<IStatePort>('STATE_PORT');
